(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-edit-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
               const itiInstances = {};
              var adphoneInputField = document.querySelectorAll(".address_phone");
              adphoneInputField.forEach((e)=>{
                var contrcode = e.dataset.contrcode;
                const iti = window.intlTelInput(e, {
                    initialCountry: contrcode,
                    hiddenInput: () => ({ phone: "address[phone]" }),
                    geoIpLookup: callback => {
                      fetch("/browsing_context_suggestions.json")
                        .then(res => res.json())
                        .then(data => callback(data.detected_values.country.handle))
                        .catch(() => callback("us"));
                    },
                    strictMode: true,
                    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
                   
                });
              itiInstances[e.id] = iti;
              });
              

                 $(document).on("click",".update-btn",function(){
                  var current_button = $(this);
                  $(current_button).addClass('is-animating disabled');
                  var errormsg = 'This field is requried.';
                  var form_id = $(this).closest('form').attr('id');
                  required = ["address[first_name]","address[last_name]","address[address1]","address[city]","address[zip]"];
                  for (i = 0; i < required.length; i++) {
                  var phoneinput = $('#' + form_id + ' input[name="' + required[i] + '"]');
                  if (phoneinput.val() == '' || phoneinput.val() == errormsg) {
                      phoneinput.addClass('needsfilled');
                      phoneinput.val(errormsg);
                    } 
                 }
                 var errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
                 var cfomid = $(this).attr('data-form-id');
                 const iti = itiInstances["AddressPhone_" + cfomid];
                 var adphoneinput = document.getElementById("AddressPhone_"+cfomid);
                if (!adphoneinput.value.trim()) {
                  adphoneinput.classList.add('needsfilled');
                  adphoneinput.value = 'This field is requried.';
                } else if (iti.isValidNumber()) {
                  $('#'+form_id+' input[name="address[phone]"]').val(iti.getNumber());
                  adphoneinput.classList.remove('needsfilled');
                } else {
                  const errorCode = iti.getValidationError();
                  const msg = errorMap[errorCode] || "Invalid number";
                  adphoneinput.classList.add('needsfilled');
                  adphoneinput.value = msg;
                }
                  if ($(":input").hasClass("needsfilled")) { 
                    $(current_button).removeClass('is-animating disabled');
                    return false;
                  }
                  else {
                    $(this).closest('form').submit();
                    return true;
                  }
                });
        });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-sidebar"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
          $('#opentab').click(function () {
              $('.article_wrapper').toggleClass('active');
              $('.article_content').slideToggle();
              $('#opentab').toggleClass('rotate-edge');
          });
          toggleTopButton();

      $('#scroll-top').on('click', function () {
          $('html, body').animate({ scrollTop: 0 }, 'slow');
      });

      $(window).on('scroll', function () {
          toggleTopButton();
      });

      function toggleTopButton() {
          if ($(window).scrollTop() === 0) {
              $('.top_scroll_wrapper').fadeOut();
          } else {
            if($(window).scrollTop() >= 750){
              $('.top_scroll_wrapper').fadeIn();
            }
          }
      }
      $('.article_content ul li a').on('click', function (e) {
          e.preventDefault();

          var $clickedLi = $(this).closest('li');
          var isInner = $clickedLi.closest('.inner_articleul').length > 0;

          $('.article_content li').removeClass('highlight');

          $clickedLi.addClass('highlight');

          // Scroll to the target
          var targetId = $(this).attr('href');
          var targetOffset = $(targetId).offset().top;
          var headerHeight = 90;

          $('html, body').animate({
              scrollTop: targetOffset - headerHeight
          }, 500);
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blognewsletter"] && !Shopify.designMode) return;
  try {
    $(document).ready(function(){
  //console.log('forms');
  $("form#blogsubscribeform").submit(function(){
    email = $("#email_coco-cloud");
    if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {
      email.addClass("needsfilled");email.val('Enter valid email address');}
    if ($(":input").hasClass("needsfilled")) {
      return false;
    }else {
      $('button#blogsubscribebutton').css("pointer-events", "none");
      var useremail =$("#email_coco-cloud").val();
      $.ajax({
        url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
        type: 'POST',
        data: {ajaxaction:"subscribelist",subemailaddress:useremail},
        async: true,
        success: function (response) {
          $("form#blogsubscribeform").get(0).reset()
          alert('Thanks for subscribe.');
          $('button#blogsubscribebutton').css("pointer-events", "auto");
        },
        timeout: 5000000, // sets timeout to 5 seconds
      });
      return false;
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    $('#stickycheckoutbutton').click(function(){
    $('#cartformsubmit').trigger('click');
  });

  if ($(".overview__holder").length > 0) {

      let target =   $('.overview__holder')
      // sticky bar
      $(window).on('scroll', function () {
          let targetTop =  target.offset().top
          let targetHeight =   target.innerHeight()

          let targetMass = targetTop + targetHeight
          let windowScrol = $(window).scrollTop()
          let windowScrolExtra = $(window).scrollTop() + $(window).height()

          if (windowScrolExtra > targetTop + (targetHeight/2) && windowScrol < targetMass ) {
              $("body").addClass('hide-block')
          } else {
              $("body").removeClass('hide-block')
          }
      });

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-editprofile"] && !Shopify.designMode) return;
  try {
    (function($){
      $(document).ready(function(){

        // Initialize intl-tel-input
         const phoneInputField = document.querySelector("#customer_phone");
         const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
         const iti = window.intlTelInput(phoneInputField, {
         initialCountry: "auto",
          hiddenInput: () => ({ phone: "customer_phone" }),
          geoIpLookup: callback => {
          fetch("/browsing_context_suggestions.json")
            .then(res => res.json())
            .then(data => callback(data.detected_values.country.handle))
            .catch(() => callback("us"));
         },
         strictMode: true,
         utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
        });

        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#customer_edit_profile").submit(function(){
          required = ["customer_first_name","customer_last_name"];
          email = $("#customer_email");
          for (i=0;i<required.length;i++) {
            var phoneinput = document.getElementById("customer_phone");
            if (!phoneinput.value.trim()) {
              phoneinput.classList.add('needsfilled');
              phoneinput.value = 'This field is requried.';
            } else if (iti.isValidNumber()) {
              phoneinput.classList.remove('needsfilled');
            } else {
              const errorCode = iti.getValidationError();
              const msg = errorMap[errorCode] || "Invalid number";
              phoneinput.classList.add('needsfilled');
              phoneinput.value = msg;
            }

            // if ((input.val() == "") || (input.val() == emptyerror)) {
            //   input.addClass("needsfilled");
            //   input.val(emptyerror);
            //   errornotice.fadeIn(750);
            // } else {
            //   input.removeClass("needsfilled");
            // }
          }
          var newpassword = $('#customer_password').val();
          var conformpassword = $('#customer_confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if($('#customer_password').val()!='' && $('#customer_password').val().length <8){$('#customer_password').addClass("needsfilled");$('#customer_password').val('should contain 8 characters').attr('type', 'text');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=conformpassword){
            $('#customer_password').addClass("needsfilled");
            $("#customer_confirm_password").val("Confirm Password not match with password");
            $('#customer_confirm_password').addClass("needsfilled");
            return false;

          }else {

            var $form = $('#customer_edit_profile');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#update_profile').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#update_profile').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/index.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#update_profile').prop('disabled', false);

                if(data=='Sucess'){
                  alert('Profile Update Sucessfully.');
                }else{
                  alert(data);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
        $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind("keypress", function (event) {
          var keyCode = event.which ? event.which : event.keyCode

          if ((keyCode == 43)) {
            return true;
          }else if (!(keyCode >= 48 && keyCode <= 57 )){
            return false;
          }

          var minLength = 15;
          var phone = $(this).val();
          if (phone.length > minLength){
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");$("#customer_password").attr('type', 'password');}});
    })(jQuery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filters"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
                $('.filterBy_toggle').on('click', function () {
                    let parent = $(this).parent();
                    parent.siblings().removeClass("active").children(".searchFilter_data").slideUp(100);
                    parent.toggleClass("active");
                    $(this).next(".searchFilter_data").slideToggle(100);
                })

                $(document).on('click', function (e) {
                    if (!$(e.target).closest('.filterBy_toggle, .searchFilter_data').length) {
                        $('.filterBy_toggle').parent().removeClass("active");
                        $('.searchFilter_data').slideUp(100);
                    }
                });
            }); // Search result filter
            

            $(document).ready(function() {
                $(".sortByToggle").click(function() {
                    $(".sortBy_list").toggle(); 
                    $(this).toggleClass("open");
                });
                $(".sortBy_list li").click(function() {
                    var selected_value = $(this).html();
                    var current_value = $(".sortByToggle span").html();
                    $(".sortByToggles.hideOnTab span").html(selected_value);
                    $(".sortBy_list li").removeClass("active");
                    $(this).addClass("active");
                    $(".sortBy_list").hide();
                    $(".sortByToggle").removeClass("open")
                        var sortByValue = $(this).attr('data-select');
                    //console.log("Selected sort by value:", sortByValue);
                  
                    if (sortByValue) {
                      var url = new URL(window.location.href);
                      url.searchParams.set('sort_by', sortByValue);
                      // Replace the current URL with the updated URL
                      window.history.replaceState({}, '', url);
                      window.location.reload();
                    }
                });
            }); // Short by filter


            if ($(window).width() <= 989) {
                $('.searchResult_filterBy_title').on('click', function () {
                    $(this).parent().addClass('open_filler')
                    $('html').addClass('showfillter')
                    $(".sortBy_list").hide();
                });

                $("#search_title_heading").click(function () {
                    $('.searchResult_outer').removeClass('open_filler')
                    $('html').removeClass('showfillter')
                });

                $('.cross_right_l').click(function () {
                    $('.searchResult_outer').removeClass('open_filler')
                    $('html').removeClass('showfillter')
                })
            } // fillter for mobiles
  
  // jQuery code
  $(document).on("click", ".searchFilter_toggle", function () {
    $(this).parent().siblings().removeClass("active");
    $(this).parent().siblings().find(".searchFilter_data").slideUp();
    $(this).parent().toggleClass("active");
    $(this).next(".searchFilter_data").slideToggle(200);
  });

  $(document).ready(function () {
    $('.searchFilterTab .filterTab').click(function () {
      var tab_id = $(this).attr('data-tab');
      $(this).siblings().removeClass('active-tab');
      $("#" + tab_id).siblings().removeClass('active-tab');
      $(this).addClass('active-tab');
      $("#" + tab_id).addClass('active-tab');
    });
  });

  // Vanilla JavaScript code
  // Get all checkbox and radio input elements
  var inputs = document.querySelectorAll('.check_label input[type="checkbox"], .check_label input[type="radio"]');

  // Add event listener to each input
  inputs.forEach(function(input) {
    input.addEventListener('change', function(event) {
      // Check if the input is checked
     // if (input.checked) {
        // Submit the form
        document.getElementById('filterForm').submit();
     // }
    });
  });

  // Slider functionality
  function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#FF9CCA', toSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
    displayValOne.textContent = '$'+to;
  } else {
    displayValOne.textContent = '$'+from;
    fromInput.value = from;
  }
}

function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#FF9CCA', toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
    displayValTwo.textContent = '$'+to;
  } else {
    toInput.value = from;
    toSlider.value = from;
    displayValTwo.textContent = '$'+from;
  }
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.max-to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
      ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
      ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} 100%)`;
}

function setToggleAccessible(currentTarget) {
  const toSlider = document.querySelector('#range-max');
  if (Number(currentTarget.value) <= 0 ) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

const fromSlider = document.querySelector('#range-min');
const toSlider = document.querySelector('#range-max');
const fromInput = document.querySelector('#min-value');
const toInput = document.querySelector('#max-value');
const displayValOne = document.getElementById("priceRange-min");
const displayValTwo = document.getElementById("priceRange-max");

fillSlider(fromSlider, toSlider, '#C6C6C6', '#FF9CCA', toSlider);
setToggleAccessible(toSlider);

fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput,displayValOne);
toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput,displayValTwo);
  // var sliderOne = document.getElementById("range-min");
  // var sliderTwo = document.getElementById("range-max");
  // var displayValOne = document.getElementById("priceRange-min");
  // var displayValTwo = document.getElementById("priceRange-max");
  // var minGap = 0;
  // var sliderTrack = document.querySelector(".priceRange");
  // var sliderMaxValue = parseInt(sliderOne.getAttribute("max"));

  // function slideOne() {
  //   if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
  //     sliderOne.value = parseInt(sliderTwo.value) - minGap;
  //   }
  //   var s1 = sliderOne.value;
  //   displayValOne.textContent = s1;
  //   document.getElementById("min-value").value = s1;
  //   console.log(sliderOne.value);
  //   fillColor();
  // }

  // function slideTwo() {
  //   if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
  //     sliderTwo.value = parseInt(sliderOne.value) + minGap;
  //   }
  //   var s2 = sliderTwo.value;
  //   displayValTwo.textContent = s2;
  //   document.getElementById("max-value").value = s2;
  //   fillColor();
  // }

  document.querySelectorAll("#range-max, #range-min").forEach(function(input) {
    input.addEventListener("change", function() {
      submitForm();
    });
  });

  // function fillColor() {
  //   var percent1 = (sliderOne.value / sliderMaxValue) * 100;
  //   var percent2 = (sliderTwo.value / sliderMaxValue) * 100;
  //   sliderTrack.style.background = `linear-gradient(to right, #C2CEDD ${percent1}% , #E6E6E6 ${percent1}% , #E6E6E6 ${percent2}%, #C2CEDD ${percent2}%)`;
  // }

  function submitForm() {
    document.getElementById("filterForm").submit();
  }

  document.addEventListener("DOMContentLoaded", function() {

    
  // Select all input elements with type checkbox
  var checkboxes = document.querySelectorAll('input[type="checkbox"], input[type="radio"]');
  
  // Loop through each checkbox
  checkboxes.forEach(function(checkbox) {
    // Check if the checkbox is disabled
    if (checkbox.disabled) {
      // If disabled, add the "changeColor" class to its parent label
      checkbox.parentElement.classList.add("changeColor");
    } else {
      // If not disabled, remove the "changeColor" class from its parent label
      checkbox.parentElement.classList.remove("changeColor");
    }
  });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["serum-bundle-option"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {

  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    async:false,
    success: function (cart) {
      $(".headerCartItems").html(Number(cart.item_count));
    }
  });
      function updateActiveState(selectedId) {
          //console.log('selectedId', selectedId)
          $('.bundlebox_bottlescontent').removeClass('active');
          var selctedoffer = '';

             if (selectedId === 6) {
                  selctedoffer = "40%";
                  freegiftshow = 4;
              } else if (selectedId === 4) {
                  selctedoffer = "36%";
                freegiftshow = 3;
              } else if (selectedId === 3) {
                  selctedoffer = "28%";
                freegiftshow = 2;
              } else {
                  selctedoffer = "13%";
                freegiftshow = 1;
              }

          $('#limited_offer').text(selctedoffer);

          let selectedBottle = $('.bundlebox_bottlescontent[data-id="' + selectedId + '"]');
          selectedBottle.addClass('active');
          selectedBottle.find('input[type="radio"]').prop('checked', true);

          $('.bundlebox_card').removeClass('is-active');
        let bundlebox_card = document.querySelectorAll(".bundlebox_card");
         for (let i = 0; i < freegiftshow; i++) {
                bundlebox_card[i].classList.add("is-active")
              }
          $('.common-btn-filled').attr('href',window.Shopify.routes.root+'pages/serum-starter-kit?quantity='+selectedId);
      }

    function getFullDate() {
  var monthNames = new Array("Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec.");
  var dayNames = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
  var now = new Date();
  now.setDate(now.getDate());
        var english_ordinal_suffix = (now.getDate() % 10 == 1 && now.getDate() != 11 ? 'st' :
            (now.getDate() % 10 == 2 && now.getDate() != 12 ? 'nd' :
            (now.getDate() % 10 == 3 && now.getDate() != 13 ? 'rd' : 'th')));
  var nowString =/* dayNames[now.getDay()] + ", " +*/ monthNames[now.getMonth()] + " " + now.getDate()+english_ordinal_suffix /*+ ", " + now.getFullYear()*/;
        var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = nowString;
        }
    }
      $('.bundlebox_bottlescontent').click(function () {
          var selectedId = parseInt($(this).attr('data-id'));
          updateActiveState(selectedId);
      });
    $('.select_scents_option').click(function(){
     var optionselected = document.querySelector('input[name="choosebottles"]:checked').value;

       dataLayer.push({ scents: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "select_scents",
            scents: parseInt(optionselected)
          });
    });
    if(window.Shopify.routes.root.includes('/es')){
  const escurrentDate = new Date(); // Gets the current date and time
  var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = escurrentDate.toLocaleDateString('es-ES', { month: 'long',  day: 'numeric' });
        }
}else{
  getFullDate();
}
  });
  } catch(e) { console.error(e); }
})();

})();
